import React from 'react';
import { Badge, Spinner } from 'react-bootstrap';
import Icon from '../../common/Icons';
import {
  PHARMACY_STATUS_VARIANT,
  SEVERITY_VARIANT,
  STOCK_STATUS_VARIANT,
  statusLabel,
  severityLabel,
  stockStatusLabel
} from '../pharmacyCopy';
import {
  formatAppDateTime,
  formatCalendarDate
} from '../../../utils/appTimezone';

export function PharmacyPageHeader({ badge, title, description, actions }) {
  return (
    <header className="cp-page-header">
      <div className="cp-page-header__main">
        <div>
          {badge ? <span className="cp-page-badge">{badge}</span> : null}
          <h1 className="cp-page-title">{title}</h1>
          {description ? <div className="cp-page-desc">{description}</div> : null}
        </div>
        {actions ? <div className="cp-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}

export function StatCard({ label, value, hint, tone = 'default', icon = 'chartBar' }) {
  return (
    <div className={`cp-stat cp-stat--${tone}`}>
      <div className="cp-stat__head">
        <span className="cp-stat__label">{label}</span>
        <span className="cp-stat__icon" aria-hidden>
          <Icon name={icon} size={16} />
        </span>
      </div>
      <div className="cp-stat__value">{value}</div>
      {hint ? <div className="cp-stat__hint">{hint}</div> : null}
    </div>
  );
}

export function StatusBadge({ status }) {
  return <Badge bg={PHARMACY_STATUS_VARIANT[status] || 'secondary'}>{statusLabel(status)}</Badge>;
}

export function SeverityBadge({ severity }) {
  if (!severity || severity === 'NONE') return <Badge bg="success">{severityLabel('NONE')}</Badge>;
  return <Badge bg={SEVERITY_VARIANT[severity] || 'secondary'}>{severityLabel(severity)}</Badge>;
}

export function StockStatusBadge({ status }) {
  return <Badge bg={STOCK_STATUS_VARIANT[status] || 'secondary'}>{stockStatusLabel(status)}</Badge>;
}

export function LoadingBlock({ label = 'Chargement…' }) {
  return (
    <div className="cp-empty">
      <Spinner animation="border" size="sm" variant="success" />
      <div className="mt-2 small">{label}</div>
    </div>
  );
}

export function EmptyBlock({ label = 'Aucune donnée.' }) {
  return <div className="cp-empty">{label}</div>;
}

export function formatDate(value) {
  if (!value) return '—';
  return formatCalendarDate(value);
}

export function formatDateTime(value) {
  if (!value) return '—';
  return formatAppDateTime(value, {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString('fr-FR');
}
